import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { toNumber } from 'lodash-es';
import { CoreActivationService } from '@epsilon-ams/ams-core-activation';
import { Store } from '@ngrx/store';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { Context } from '../../context/context.models';
import { selectContext } from '../../context/context.reducer';
import { AppState } from '../../reducers';
import { UtilsService } from '../../utils/utilservice';

@UntilDestroy()
@Component({
  selector: 'lib-ams-details',
  templateUrl: './ams-details.component.html',
  styleUrl: './ams-details.component.sass',
  standalone: false
})
export class AmsDetailsComponent implements OnInit {

  amsAudienceId: string;
  activationId: number;
  context: Context;
  returnRoute: string;

  constructor(private router: Router, private route: ActivatedRoute, private coreActivationService: CoreActivationService, private store: Store<AppState>, private utilsService: UtilsService) {
  }

  ngOnInit() {
    this.store
      .select(selectContext)
      .pipe(untilDestroyed(this))
      .subscribe(ctx => {
        this.context = ctx;
        this.setAudienceDetails();
      });
  }

  setAudienceDetails() {
    this.returnRoute = this.utilsService.getProductBaseUrl(this.router, this.route) + '/';
    this.route.snapshot.parent?.parent?.parent?.url?.forEach(url => { this.returnRoute = this.returnRoute.concat(url.path).concat('/'); });
    this.route.snapshot.parent?.parent?.url?.forEach(url => { this.returnRoute = this.returnRoute.concat(url.path).concat('/'); });
    this.returnRoute = '/'+this.returnRoute+'deliveries';
    this.coreActivationService.parentRoute$.next(this.returnRoute);
    this.coreActivationService.companyId$.next(this.context?.metadata?.amsCompanyId);
    this.amsAudienceId = this.route.snapshot.queryParamMap.get('audienceId');
    const id = this.route.snapshot.queryParamMap.get('activationId');
    if(id) {
      this.activationId = toNumber(id);
    }
  }
}
